function ChevronLeft({ size }: { size: number }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.173 20L7.58601 13.4131C7.21079 13.0377 7 12.5287 7 11.998C7 11.4673 7.21079 10.9583 7.58601 10.5829L14.1689 4L15.1123 4.94337L8.52939 11.5263C8.40431 11.6514 8.33405 11.8211 8.33405 11.998C8.33405 12.1749 8.40431 12.3446 8.52939 12.4697L15.1163 19.0566L14.173 20Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default ChevronLeft
